import React from 'react';
import { I18n } from 'react-redux-i18n';
import CarTypeMappingItem from './CarTypeMappingItem';

const CarTypeMapping = ({
  affiliationCarTypes = [], // List AffiliationCarType từ API
  mappings = {},            // { affiliationCarTypeId: fleetCarTypeId }
  carTypeOptions,
  onChange,
  getSelectedCarType,
  checkCapacityWarning,
  isLoading,
}) => {
  if (isLoading) {
    return (
      <div className="network-setting-section">
        <h3 className="section-title">{I18n.t('networkSetting.CarTypeMapping')}</h3>
        <div className="loading-spinner">{I18n.t('networkSetting.Loading')}</div>
      </div>
    );
  }

  return (
    <div className="network-setting-section">
      <h3 className="section-title">{I18n.t('networkSetting.CarTypeMapping')}</h3>
      <p className="section-description">
        {I18n.t('networkSetting.CarTypeMappingDes')}
      </p>
      <div className="car-type-mapping-grid">
        {affiliationCarTypes
          .filter(item => item.isActive !== false) // Chỉ hiển thị active items
          .sort((a, b) => (a.no || 0) - (b.no || 0)) // Sort theo field 'no'
          .map((affiliationCarType) => (
            <CarTypeMappingItem
              key={affiliationCarType._id}
              affiliationCarType={affiliationCarType}
              selectedCarTypeId={mappings[affiliationCarType._id] || ''}
              carTypeOptions={carTypeOptions}
              onChange={onChange}
              getSelectedCarType={getSelectedCarType}
              checkCapacityWarning={checkCapacityWarning}
            />
          ))}
      </div>
    </div>
  );
};

export default CarTypeMapping;